import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { operationType, selectDataType } from "../../../../../services/types";
import { Select } from "../../../../form/select";
import { updateNodeValue } from "../../../../../services/method";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";
import { Main, Styled } from "./style";
import { TextInput } from "../../../../form/textInput";

type RoutingProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function FilterBlock({ id, data, setChildMinimize, setChildSettings }: RoutingProps) {
   const [requests, setRequests] = React.useState<selectDataType[]>([
      { id: 1, name: 'Is empty', refId: 'is_empty', isActive: true },
      { id: 2, name: 'Is not empty', refId: 'not_empty' },
      { id: 3, name: 'Starts with', refId: 'starts_with' },
      { id: 4, name: 'Ends with', refId: 'ends_with' },
      { id: 5, name: 'Contains', refId: 'contains' },
      { id: 6, name: 'Does not contain', refId: 'not_contains' },
      { id: 7, name: 'Greater than', refId: 'greater_than' }, 
      { id: 8, name: 'Less than', refId: 'less_than' }, 
      { id: 9, name: 'Equal', refId: 'equal'}, 
      { id: 10, name: 'Not equal', refId: 'not_equal' }, 
      { id: 11, name: 'Greater than or equal to', refId: 'greater_equal' }, 
      { id: 12, name: 'Less than or equal to', refId: 'less_equal' }, 
      { id: 13, name: 'Matches regex', refId: 'regex' }, 
   ]);
   const { setNodes } = useReactFlow();
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      setRequests(requests => requests.map(request => ({ ...request, isActive: request.refId === (data.value?.request || requests[0].refId )})));
      if (!data.value?.request) updateNodeValue(id, setNodes, { request: requests[0].refId });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // ---
   const handleSelectRequest = (selectId: number) => {
      setRequests((requests) => requests.map((request) => {
         if (request.id === selectId) return { ...request, isActive: true };
         else return { ...request, isActive: false };
      }));
      updateNodeValue(id, setNodes, { request: requests.find(obj => obj.id === selectId)?.refId });
   }
   // ---
   const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>, keyRef?: string) => {
      if (keyRef) updateNodeValue(id, setNodes, { [keyRef]: e.target.value });
   }

   // ---
   const isWarning = false;

   return (<>
      <SettingsBlock nodeId={ id } data={ settings } setData={ setSettings } />
      <Main>
         {isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '380px' }}
         ><Styled>
            <Select data={ requests } handleSelectItem={ handleSelectRequest } isSmall={ true } />
            <TextInput keyRef="field" value={ data.value?.field } placeholder="Field" handleChange={ handleChangeInput } />
            { !['is_empty', 'not_empty'].includes(data.value?.request) ? <TextInput keyRef="value" value={ data.value?.value } placeholder="value" handleChange={ handleChangeInput } /> : null }
            <p className="empty">The data passed to the filter must be an array</p>
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}